import './LoadingSpinner.scss';

import React from 'react';

const LoadingSpinner: React.FC = () => (
	<div
		className='loading-spinner fixed flex items-center justify-center rounded'
		data-testid="loading-spinner">
		<div className="loading-spinner__inner">
			<div className='spinner'/>
		</div>

		<i className="ico ico-3x ico-ao-logo text-ongreen z-10" />
	</div>
);

export default LoadingSpinner;
